import apiAnalytic from '@/api/analytic'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  data: null
}

export const mutationTypes = {
  deleteAnalyticStart: '[delete analytic] Update analytic start',
  deleteAnalyticSuccess: '[delete analytic] Update analytic success',
  deleteAnalyticFailure: '[delete analytic] Update analytic failure'
}

export const actionTypes = {
  deleteAnalytic: '[delete analytic] Update analytic'
}

const mutations = {
  [mutationTypes.deleteAnalyticStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteAnalyticSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteAnalyticFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.deleteAnalytic](context, {id}) {
    context.commit(mutationTypes.deleteAnalyticStart)
    return new Promise(resolve => {
      apiAnalytic
        .deleteAnalytic(id)
        .then(response => {
          context.commit(mutationTypes.deleteAnalyticSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.deleteAnalyticFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
